/**
 * 환경 변수 enum
 */
export default {
    LOCAL: 'local',
    DEVELOP: 'develop',
    QC: 'qc',
    STAGING: 'staging',
    PRODUCTION: 'production',
};
